import { DatePipe } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { ChangeDetectorRef, Component, HostListener, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ModalDismissReasons, NgbModal, NgbPopover, NgbPopoverConfig } from "@ng-bootstrap/ng-bootstrap";
import { CsAgentAuthService } from "@spartacus/asm/root";

import { BaseSiteService, CmsService, GlobalMessageService, GlobalMessageType, OccEndpointsService, RoutingService } from "@spartacus/core";
import { UserAccountFacade } from "@spartacus/user/account/root";
import moment from 'moment';
import { defineLocale, enGbLocale } from "ngx-bootstrap/chronos";
import { BsLocaleService } from "ngx-bootstrap/datepicker";
import { Observable, of, Subscription } from "rxjs";
import { catchError, filter, map, take } from "rxjs/operators";
import { CustomAddToCartService } from "src/app/custom-add-to-cart/custom-add-to-cart.service";
import { ProductDetailsComponent } from "src/app/custom-add-to-cart/custom-add-to-cart/product-details/product-details.component";
import { CustomProdPgService } from "src/app/custom-prod-pg/custom-prod-pg.service";
import { BaseService } from "src/app/shared/services/base.service";
import { CartEntryService } from "src/app/shared/services/cart-entry.service";
import { DataLayerService } from 'src/app/shared/services/data-layer.service';
import { SharedService } from "src/app/shared/services/shared.service";
import { NumberSix, NumberTen, NumberThree } from "src/app/shared/utils/constants/global.constants";
import { ProductUtils } from "src/app/shared/utils/productUtils";
import * as _ from 'underscore';
import * as config from '../../../app/shared/config/app.config';
import { otherDiscounts, saleTax } from '../../shared/utils/constants/global.constants';
import { CustomAuthService } from '../../custom-auth-service.service';

@Component({
    selector: 'app-checkout-module',
    templateUrl: './checkout-module.component.html',
    styleUrls: ['./checkout-module.component.scss'],
    standalone: false
})
export class CheckoutModuleComponent implements OnInit, OnDestroy {
  headerLevelObj: any;
  deliveryPickup: string = 'delivery';
  isSticky: boolean = false;
  emailErrorMsg: boolean = false;
  phoneErrorMsg: boolean = true;
  orderByErrorMsg: boolean = false;
  EmailforContact: any;
  contactDetails2: any;
  isaddnewemailadded: any;
  selectedPaymentMethodDetails: any;
  selectedCardOrAccountDetails: any;
  emailFinalArr: any = [];
  mobFinalArr: any = [];
  shipToArr: any = [];
  lastcarddigit: any;
  paymentMethod: any;
  faxErrorMsg: boolean = true;
  ErrMsg = 'Please select a valid Email address';
  mobileErrorMsg: boolean = true;
  contactDetails: any;
  contactDetailsSub: any;
  phoneNo: any;
  mobileNo: any;
  faxValid: boolean = true;
  cMethodVal: boolean = true;
  public productInfo: {
    available: boolean;
    availabilityText: string;
    batchInfo: {
      batchNumber: string;
      expiryDate: string;
      quantity: number;
    };
    images: any;
    code: string;

    description: string;
    discontinued: boolean;
    sapAllocation: boolean;
    displayProduct: boolean;
    flu: boolean;
    nameHtml: any;
    summary: any;

    productUpdate: string;
    productDocuments: {
      productDocument: [
        {
          url: string;
        }
      ];
    };
    name: string;
    orderable: boolean;
    quantityPerUnit: number;
    productUpdates: string;
    productDocument: any;
    volumePrices: [
      {
        currencyIso: string;
        formattedValue: string;
        maxQuantity: string;
        minQuantity: string;
        priceType: string;
        value: string;
      }
    ];
    url: string;
    stock: {
      isValueRounded: boolean;
    };
    isValueRounded: boolean;
    yellowFever: boolean;
    volumePricesFlag: boolean;
  } = null;
  standardCartDetails: any;
  productEntries: any = [];
  public images: any;
  updateTotal: boolean;
  updateEntriesData: any = [];
  subTotal: number;
  baseUrl: string;
  minDeliveryDate = new Date();
  maxDeliveryDate = new Date();
  minPickupDate = new Date();
  maxPickupDate = new Date();
  currentTime = new Date().getHours();
  pickupTimeFormat: any = [];
  timeFormat: any;
  selectedTime: any;
  deliveryDate: Date;
  deliveryCrossIcon: boolean;
  pickupDate: Date;
  deliveryDateFormat: string;
  pickupDateFormat: string;
  pickupCrossIcon: boolean;
  fallbackImage = 'i18n-assets/sanofi_missing_product.jpg';
  closeResult = '';
  usergetDataObj: any;
  getuserData: any;
  searchedClientList: any;
  selectedData: any;
  listSelectedData: any;
  userAccountgetData: any;
  saveCartName: string;
  popoverConfig: NgbPopoverConfig;
  cartId: any;
  errorMsg: string;
  deleteSuccess: string;
  addSuccess = false;
  cartItems: any;
  totalSavings = 0.0;
  subTotalVal = 0.0;
  totalWithPromtPayDiscountSum = 0.0;
  finalSaving = 0.0;
  changeLocation = false;
  templatePage: any;
  prodAddedSub: Subscription;
  cartItemsSub: Subscription;
  removeEntriesSub: Subscription;
  deleteCartSub: Subscription;
  cartDetailsSub: Subscription;
  checkoutDetailsSub: Subscription;
  checkoutFailedSub: Subscription;
  userAccountDetailsSub: Subscription;
  changedLocSub: Subscription;
  saveCartInvalidSub: Subscription;
  saveCartSuccessSub: Subscription;
  plpMiniCartSub: Subscription;
  userDataSub: Subscription;
  emailArr = [{ id: null, value: '', iserror: false, itemValue: '' }];
  emailList = [
    { id: '1', value: 'test@12.com' },
    { id: '2', value: 'test@1234562.com' },
  ];
  mobileList = [{ value: '', iserror: false }];
  emailArrCopy = [];
  noshowaddmobile: boolean = false;
  noshowaddemail: boolean = false;
  @ViewChild('p2') public savePopover: NgbPopover;
  orderBlock = false;
  showDangerAlert = false;
  checkoutClicked = false;
  checkoutCartClicked = false;
  isCheckoutCartLoading = true;
  yfEntry = false;
  urlPath: string;
  localSubscription: any;
  panelProductExpanded2 = false;
  panelProductExpanded = true;
  b2bUnitId: any;
  b2b: any;
  cartProdDetails: Subscription;
  expandedItems: boolean[] = [];
  stdCartDetails: any;
  orderContactDetails: any;
  payerAddress: any;
  checkoutCartDetailsSub: Subscription;
  checkoutCartFailedSub: Subscription;
  selfInitAccountIdSub: Subscription;
  selfInitUserAccountSub: Subscription;
  selfInitAllCartsSub: Subscription;
  selfInitCartCheckSub: Subscription;
  selfInitCheckoutFailedSub: Subscription;
  selfHealInFlight = false;
  baseSiteId: string;
  isFutershipAdded = false;
  punchoutCheckout: boolean = false;
  punchoutId: string;
  punchoutCheckoutData: any;
  pdfUrl: any;
  error_message_dating: string;
  buyer_form_post_url: any;
  xml: any;
  showFax: boolean = true;
  isAsmUser: boolean = false;
  csAgentAuthSubscription: Subscription;
  punchOutKey: boolean;

  otherDiscountsFlag: string;
  salesTaxFlag: string;
  constructor(
    protected modal: NgbModal,
    private readonly baseService: BaseService,

    private readonly cdr: ChangeDetectorRef,
    private readonly addToCart: CustomAddToCartService,
    readonly user: UserAccountFacade,
    private readonly modalService: NgbModal,
    private localeService: BsLocaleService,
    public datepipe: DatePipe,
    private readonly config: NgbPopoverConfig,
    private readonly route: RoutingService,
    private readonly occEndPoint: OccEndpointsService,
    private readonly plpService: CustomProdPgService,
    private globalMessage: GlobalMessageService,
    private readonly pageDate: CmsService,
    private readonly sharedService: SharedService,
    private readonly routeService: ActivatedRoute,
    private readonly authService: CustomAuthService,
    private baseSiteService: BaseSiteService,
    private readonly csAgentAuthService: CsAgentAuthService,
    private readonly http: HttpClient,
    private router: Router,
    private _dataService: DataLayerService,
    private readonly cartEntryService: CartEntryService
  ) {
    this.images = {};
    this.updateTotal = false;
    enGbLocale.weekdaysShort = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
    enGbLocale.week.dow = 0;
    defineLocale('en-gb', enGbLocale);
    this.localeService.use('en-gb');
    this.pickupTimeFormat = [
      '09:00 am',
      '10:00 am',
      '11:00 am',
      '12:00 pm',
      '01:00 pm',
      '02:00 pm',
      '03:00 pm',
      '04:00 pm',
      '05:00 pm',
    ];
    this.selectedTime = null;
    config.autoClose = 'outside';
    this.deleteSuccess = '';
    this.addSuccess = false;
    this.baseSiteService
      .getActive()
      .pipe(take(1))
      .subscribe((res) => (this.baseSiteId = res));
  }
  @HostListener('window:scroll', ['$event'])
  checkScroll(event) {
    if (window.pageYOffset >= 150) {
      this.isSticky = true;
    } else {
      this.isSticky = false;
    }

  }

  redirectToCart() {
    this.cartEntryService.goToCart();
  }

  ngOnInit(): void {
    this.otherDiscountsFlag = otherDiscounts;
    this.salesTaxFlag = saleTax;
    if (localStorage.getItem('punchout-sid-key') != null) {
      this.punchOutKey = true;
    }
    this.csAgentAuthSubscription = this.csAgentAuthService.isCustomerEmulated().subscribe((res) => {
      this.isAsmUser = res ? res : false;
    });
    this.punchoutCheckout = localStorage.hasOwnProperty('punchout-sid-key');
    this.localSubscription = this.authService
      .isUserLoggedIn()
      .subscribe((res) => {
        if (sessionStorage.getItem('counter') == null) {
          sessionStorage.setItem('counter', '1');
        } else {
          let temp = Number(sessionStorage.getItem('counter'));
          temp = temp + 1;
          sessionStorage.setItem('counter', String(temp));
        }
      });
    this.authService.logoutInProgress$.subscribe((res) => {
      if (res) {
        this.authService.isUserLoggedIn().subscribe((res) => {
          if (!res) {
            sessionStorage.removeItem('counter');
          }
        });
      }
    });
    this.error_message_dating = "Product may have less than 6 months dating."
    this.globalMessage.remove(GlobalMessageType.MSG_TYPE_ERROR);
    this.plpMiniCartSub = this.plpService
      .getUpdateMiniCart()
      .subscribe((res) => {
        if (res) {
          this.addToCart.removedEntries(res, this.userAccountgetData?.uid);
          this.removeEntriesMapping();
        }
      });
    this.plpService.stdCartMsg.next(false);
    this.baseUrl = this.occEndPoint.getBaseUrl({
      baseUrl: true,
      prefix: false,
      baseSite: false,
    });
    this.pageDate.getCurrentPage().subscribe((res) => {
      if (res) {
        this.templatePage = res?.template;
      }
    });
    this.pageDate
      .getComponentData("pdfReservationGuideComponent")
      .pipe(
        filter((res: any) => !!res && !!res.document?.url),
        take(1)
      )
      .subscribe((res: any) => {
        this.pdfUrl = this.baseUrl + res.document.url;
        this.cdr.detectChanges();
      });
    this.userDataSub = this.user.get().subscribe((res) => {
      if (res && res != null) {
        this.userAccountgetData = res;

        this.getUserAccountData(this.userAccountgetData.uid);






        this.productEntries = [];


        this.getCartDetails();
        this.cdr.detectChanges();


      }
    });
    this.prodAddedSub = this.plpService.stdCartMsg$.subscribe((res) => {
      if (res) {
        this.addSuccess = true;
        this.deleteSuccess = '';
        this.plpService.stdCartMsg.next(false);
      }
    });
    this.setDeliveryDate();
    this.setPickupDate();
  }









  addemail() {
    if (this.emailArr.length <= 3) {
      this.emailArr.push({
        id: null,
        value: '',
        iserror: false,
        itemValue: '',
      });
      if (this.emailArr.length === 3) {
        this.noshowaddemail = true;
      }
    }
  }
  updateValidity() {
    this.faxValid = true;
    this.faxErrorMsg = true;
  }
  addnewEmail(event, emailIndex, callingFrom?) {
    if (event === 'Add new email') {
      this.emailArr[emailIndex].id = '-1';
      this.emailArr[emailIndex].value = callingFrom === 'cMethodVal' ? 'Add new email' : '';
    } else {
      this.emailArr[emailIndex].id = '';
      this.emailArr[emailIndex].itemValue = '';
      this.emailArr[emailIndex].value = event;
      this.EmailforContact = event;
      this.emailNullCheckValidation();
    }
  }

  validateEmail(emailID) {








    let val = (/^[\w-\.]+@([\w-]+\.)+[\w-]{2,15}$/g).test(emailID);
    return val;
  }

  addMobile() {
    if (this.mobileList.length <= 3) {
      this.mobileList.push({ value: '', iserror: false });
      if (this.mobileList.length === 3) {
        this.noshowaddmobile = true;
      }
      setTimeout(() => {
        let data = `faxcontactmethod_${this.mobileList.length - 1}`
        document.getElementById(data).focus();
      }, 400);

    }
  }

  emailNullCheckValidation() {
    for (let i = 0; i < this.emailArr.length; i++) {
      if (this.emailArr[i].id === '-1' && this.emailArr[i]["itemValue"] === '') {
        this.emailArr[i].iserror = true;
        this.ErrMsg = "Email field should not be blank"
        return false;
      }
      else if (this.emailArr[i].id === '-1' && this.emailArr[i]["itemValue"] !== '') {
        if (!this.validateEmail(this.emailArr[i]["itemValue"])) {
          this.emailArr[i].iserror = true;
          this.ErrMsg = "Please enter a valid email address"
          return false;
        }
        else {
          this.emailArr[i].iserror = false;
          this.ErrMsg = "";
        }
      }
      else if (this.emailArr[i].id !== '-1' && this.emailArr[i].value === '') {
        this.emailArr[i].iserror = true;
        this.ErrMsg = "Please select a valid Email address"
        return false;
      }
      else if (this.emailArr[i].id === null && this.emailArr[i].value === '') {
        this.emailArr[i].iserror = true;
        this.ErrMsg = "Please select a valid Email address"
        return false;
      }
      else {
        this.emailArr[i].iserror = false;

      }

    }
    return true;
  }

  poCheck(locSpecificCart) {
    if (locSpecificCart?.poMandatory && locSpecificCart?.POnumber?.trim()?.length === 0) {
      locSpecificCart['poError'] = true;
    }
    else {
      locSpecificCart['poError'] = false;
    }
    this.cdr.detectChanges();
  }

  selectedCardOrAccountDetailsMethod(event) {
    this.selectedCardOrAccountDetails = event;

    const scrollOptions: ScrollToOptions = {
      top: window.scrollY + 5,
      behavior: 'auto'
    };
    window.scrollTo(scrollOptions);
    this.cdr.detectChanges();
  }
  selectedPaymentMethodDetailsMethod(event) {
    this.selectedPaymentMethodDetails = event;
    this.cdr.detectChanges();
  }

  openmodal(content) {




    let currDate = this.datepipe.transform(new Date(), 'MM/yyyy');
    if ((this.selectedPaymentMethodDetails?.code === 'PAY_BY_CARD' || this.selectedPaymentMethodDetails?.code === "PAY_BY_CREDIT_CARD_3DPRIOR")
      && currDate === this.selectedCardOrAccountDetails.expDate) {
      this.globalMessage.add("Your credit card is expired, please update your card and proceed.",
        GlobalMessageType.MSG_TYPE_ERROR
      );
      return false;
    }

    let poerror = false;
    this.stdCartDetails?.forEach((locSpecificCart, index) => {
      if (!this.punchOutKey && locSpecificCart?.poMandatory && locSpecificCart?.POnumber?.trim()?.length === 0) {
        locSpecificCart['poError'] = true;
        poerror = true;
        let poElement = document.getElementById('po_' + index);
        if (poElement) {
          poElement.focus();
        }
        this.cdr.detectChanges();
      }

    });
    if (poerror && !this.punchOutKey) {
      return;
    }
    let orderByError = false;
    if (this.contactDetails?.contactName?.trim()?.length === 0) {
      orderByError = true;
      this.cdr.detectChanges();
    }
    if(this.isAsmUser) {
      if (this.contactDetails?.asmContactName?.trim()?.length === 0) {
        orderByError = true;
        this.orderByErrorMsg = true;
        this.cdr.detectChanges();
      } else {
        this.orderByErrorMsg = false;
      }
    }
    if (orderByError) {
      return;
    }
    this.punchoutCheckout = localStorage.hasOwnProperty('punchout-sid-key');
    if (this.punchoutCheckout) {
      this.punchoutId = localStorage.getItem('punchout-sid-key');
    }
    if (!this.cMethodVal) {
      if (this.contactDetails.contactFax === undefined) {
        this.faxValid = false;
      } else {

        this.faxValid = true;
      }
    }

    if (!this.punchoutCheckout) {
      if (this.faxValid && this.phoneErrorMsg && this.faxErrorMsg) {
        if (this.selectedPaymentMethodDetails.code === 'PAY_BY_CARD') {
          let cardNumbrArr =
            this.selectedCardOrAccountDetails.cardNumber.split('-');
          this.lastcarddigit = cardNumbrArr[2];
          this.paymentMethod =
            this.selectedPaymentMethodDetails.name +
            ' <br />' +
            '(*' +
            this.lastcarddigit +
            ')';
        }

        else if (this.selectedPaymentMethodDetails.code === "PAY_BY_CHK_ACCOUNT") {
          let cardNumbrArr =
            this.selectedCardOrAccountDetails.cardNumber.split('-');
          this.lastcarddigit = cardNumbrArr[2];
          this.paymentMethod =
            this.selectedPaymentMethodDetails.name +
            ' <br />' +
            '(*Account ending in ' +
            this.lastcarddigit +
            ')';
        }
        else if (this.selectedPaymentMethodDetails.code === "PAY_BY_CREDIT_CARD_3DPRIOR") {
          let cardNumbrArr =
            this.selectedCardOrAccountDetails.cardNumber.split('-');
          this.lastcarddigit = cardNumbrArr[2];
          this.paymentMethod =
            this.selectedPaymentMethodDetails.name +
            '(*' + this.lastcarddigit + ')';
        }
        else if (this.selectedPaymentMethodDetails.code === "PAY_BY_CHK_ACCOUNT_3DPRIOR") {
          let cardNumbrArr =
            this.selectedCardOrAccountDetails.cardNumber.split('-');
          this.lastcarddigit = cardNumbrArr[2];
          this.paymentMethod =
            this.selectedPaymentMethodDetails.name +
            '(*' + this.lastcarddigit + ')';
        }
        else {




          this.paymentMethod = this.selectedPaymentMethodDetails.name;


        }

        if (this.emailNullCheckValidation()) {
          this.modal.open(content, {
            centered: true,
            backdrop: 'static',
            windowClass: `locStripModal ${this.baseSiteId}`,

          });
        }
      }
    }
    else { //for punchout directly open the modal
      this.modal.open(content, {
        centered: true,
        backdrop: 'static',
        windowClass: `locStripModal ${this.baseSiteId}`,

      });
    }
  }
  getRequestedDate(dt) {
    if (dt) {
      let formatedDate = dt?.split('T');
      let splitDateF = formatedDate[0].split('-');

      let finalFormatedDate =
        splitDateF[1] + '/' + splitDateF[2] + '/' + splitDateF[0];

      return finalFormatedDate;
    }
  }

  punchoutCheck() {
    if (this.punchoutId) {
      this.addToCart.punchoutCheckout(this.punchoutId);
    }
    this.punchoutCheckoutData = this.addToCart.punchoutCheck.subscribe(data => {
      if (data) {




        let form = $('<form></form>');
        let field = $('<input></input>');
        field.attr("type", "hidden");
        field.attr("name", "cxml-base64");
        field.attr("value", data.orderAsCXML);
        form.append(field);

        form.attr("method", "post");
        form.attr("action", data.browseFormPostUrl);

        $(document.body).append(form);
        form.submit();
        this.punchoutCheckoutData.unsubscribe();
      }





























    });
  }

  getCartDetails() {
    this.addToCart.checkoutCartDetails$.pipe(filter(res => !!res), take(1)).subscribe(res => {
      this.isCheckoutCartLoading = false;
      this.selfHealInFlight = false;

      if (res?.carts[0]?.hasOwnProperty('cartModifiedMessage') &&
        !!res?.carts[0]?.cartModifiedMessage
      ) {
        if (!this.router?.url?.includes('/orderConfirmation')) {
          this.globalMessage.add(
            this.convertHtmlToPlainTxt(res?.carts[0].cartModifiedMessage[0]),
            GlobalMessageType.MSG_TYPE_ERROR, 5000000
          );
          setTimeout(() => {
            this.cartEntryService.goToCart();
          }, 15000);
        }

      }
      else {
        this.cartDataMapping(res?.carts[0]);
      }
    });

    // checkoutCartDetails$ is normally populated by the cart page's "Proceed
    // to Checkout" button (checkoutCartPage()) before the Angular router
    // navigates here in the same SPA session. Arriving here any other way -
    // a direct/external navigation, a refresh, a bookmark - skips that call
    // entirely, so the subscription above waits forever and the page is
    // stuck showing "0 Units". Self-heal by resolving the cart and calling
    // checkoutCartPage() ourselves when nothing has populated it yet.
    //
    // Deliberately NOT attempting to detect a *stale* value here (e.g. the
    // user checked out cart A earlier this session, then reaches checkout
    // for cart B via back/forward without the button click running again -
    // see PR #14312 review). The only signal available for "what's the
    // current cart" is the same best-effort heuristic the fallback below
    // uses (latest non-saved cart from getAllCarts), which is not reliable
    // enough to safely override an already-populated value: doing so
    // regressed the common case (button click already got the right cart,
    // but the heuristic picked a *different* one and overwrote it -
    // reported after an earlier version of this fix). Accepting the
    // staleness risk is safer than a heuristic that can corrupt the
    // already-correct path.
    if (!this.addToCart.checkoutCartDetails.value) {
      this.ensureCheckoutCartDetailsFresh();
    }

    this.baseService.get(config.GET_ACCOUNT_ID).subscribe((res) => {
      this.b2b = res?.defaultB2BUnit?.uid;
      this.contactDetailsSub = this.addToCart
        .getOrderContactDetails(this.userAccountgetData.uid, this.b2b)
        .pipe(filter(res => !_.isEmpty(res))).subscribe((res) => {
          if (res.contactEmail) {
            this.emailArr[0].value = res.contactEmail;

            if(res?.customerEmails?.length === 0) {
              res?.customerEmails.push(res?.contactEmail)
            }

          }
          this.contactDetails = res;
          if(this.isAsmUser) {
            this.contactDetails.asmContactName = '';
          }
          if (this.contactDetails?.hasOwnProperty('disableFax')) { //if disableFax false, then hide fax option
            if (this.contactDetails?.disableFax) {
              this.showFax = true;
            }
            else {
              this.showFax = false;
            }
          }
          else {
            this.showFax = true;
          }
          this.contactDetails2 = this.contactDetails.contactFax;
          this.emailList = this.contactDetails.customerEmails;
          this.contactDetails.customerEmails.push('Add new email');
          this.cdr.detectChanges();
        });
    });
    if (this.cartId && this.templatePage === 'CartPageTemplate') {
      this.addToCart.removedEntries(this.cartId, this.userAccountgetData?.uid);
      this.removeEntriesMapping();
    }
    this.addToCart.checkoutCartDetails.subscribe((el) => {
      if (el?.carts && el?.carts?.length > 0) {
        this.stdCartDetails = el?.carts[0]?.childCarts;
      }
    });

    if (Array.isArray(this.stdCartDetails)) {
      this.stdCartDetails.forEach(el => {
        this._dataService.addtoDataLayer('begin_checkout', JSON.parse(localStorage.getItem(el.shipToLoc_id + "_forDL")), el.shipToLoc_id, this.stdCartDetails.length);
      })
      this._dataService.addtoDataLayer('clearDataLayer', '', '', '');
    }
    else {
    }
  }

  /**
   * Resolves the account and the current cart independently and calls
   * checkoutCartPage() ourselves, mirroring what the cart page's "Proceed
   * to Checkout" button does (see the CART PAGE's
   * StandardCartComponent.proceedToCheckoutPage() / getUserAccountData() -
   * not this component's own like-named methods a few hundred lines down,
   * which are unrelated). Only used as a fallback when we arrive here
   * without that cart-page button ever having run in this session - see
   * the call site in getCartDetails() above. Guarded by selfHealInFlight
   * so an unrelated re-emission of the outer user.get() subscription
   * (getCartDetails()'s only caller) can't start a second, overlapping
   * resolve-and-POST chain.
   *
   * b2bUnitId is read straight from a dedicated request/response pair for
   * the resolved account (see below) - never from this.b2bUnitId /
   * userAccountDetails$ directly. That's a shared singleton also written
   * by MiniCartComponent, StandardCartComponent, EditOrdersComponent, ...;
   * a take(1) subscription to it can't distinguish a value one of those
   * already populated *for a different account* earlier in the session
   * from the fresh one this method just requested (a BehaviorSubject
   * replays whatever it currently holds immediately on subscribe) -
   * confirmed live this can otherwise checkout under the wrong B2B unit
   * (wrong pricing/contract/cost-center) with no error surfaced.
   * getUserAccountDetailsDataFromDb() is still called unconditionally
   * (matching every one of those other callers - never skipped just
   * because userAccountDetails already has *some* value) purely as a
   * fire-and-forget side effect, so the rest of the page (the order-block
   * banner, via getUserAccountData()'s own separate, ongoing subscription)
   * still updates the normal way. If the account can't be resolved at all,
   * the checkout POST is skipped entirely rather than sent under a
   * wrong/guessed business unit or with the order-block check silently
   * skipped.
   *
   * The *lookup key* passed to getUserAccountDetailsDataFromDb() (and to
   * this method's own direct b2bUnits/{accountId} request) prefers the
   * account's currently selected location (sessionStorage.selectedLocations
   * / defaultLocation, same as every other caller - see
   * StandardCartComponent.getB2BUid()) when a legacy session already has
   * one, but falls back to the account's own default unit (GET_ACCOUNT_ID)
   * when it doesn't - e.g. arriving here straight from the new Next.js
   * storefront's cart, which has no reason to know this legacy app's
   * sessionStorage conventions. That fallback matters: this method's
   * primary target scenario (USONESHOP-3639) *is* exactly that cross-app
   * arrival, so requiring session state only a legacy-app page visit would
   * set previously broke self-heal for the case it exists to fix - the
   * lookup call 404'd on `.../b2bUnits/undefined` with no error handler,
   * so nothing ever emitted and the page stayed stuck.
   *
   * Calls cartCheck() (POST /checkcart/{cartId}) before checkoutCartPage() -
   * confirmed live (see PR #14312 review + HAR traces) this is required:
   * the cart page calls it on every load (StandardCartComponent's
   * getCartDetails()) to get S4/SAP to (re)validate the cart and compute
   * each childCart's *available* delivery-date options before the user
   * ever reaches "Proceed to Checkout".
   *
   * Critically, deliveryDate prefers childCart.requestedDeliveryDate when
   * it still matches one of cartCheck()'s deliveryDates (the array of
   * currently-valid, S4-computed future options) - e.g. dates already
   * stamped by the Next.js cart flush or a prior checkout POST. The
   * matching shippingDate comes from the shippingInfos row whose
   * deliveryDate equals the chosen slot (same pairing as
   * StandardCartComponent.proceedToCheckoutPage()), not index [0].
   * When requestedDeliveryDate is missing, unparsable, or no longer in
   * deliveryDates (stale/past slot that validateSelectedDeliveryDates()
   * would reject), fall back to deliveryDates[0]. The shippingDate is then
   * selected from shippingInfos by matching deliveryDate (or left blank if
   * no matching row exists).
   *
   * Also has exactly one entry per childCart - the checkout endpoint
   * rejects the whole request the same way when an entry is missing for
   * any childCart. Dates are stamped as YYYY-MM-DD via the calendar-day
   * prefix before any 'T' (same idea as getRequestedDate()) so date-only
   * and OCC ISO timestamps compare without a local-time shift; a childCart
   * with no options at all (shouldn't happen post-cartCheck(), but the
   * field is technically optional) still gets an entry, just with
   * deliveryDate/shippingDate left as '' rather than guessing - mirrors
   * proceedToCheckoutPage()'s own real-flow shape (always one obj per
   * childCart in stdCartDetails). Known gap vs. the real flow: no per-item
   * ship-now override - a real difference, but one that needs a
   * product/business decision, not a guess; tracked as a follow-up rather
   * than blocking this fix.
   */
  private ensureCheckoutCartDetailsFresh(): void {
    if (this.selfHealInFlight) return;

    const userId = this.userAccountgetData?.uid;
    if (!userId) {
      this.isCheckoutCartLoading = false;
      return;
    }

    this.selfHealInFlight = true;

    this.selfInitAccountIdSub = this.resolveSelfHealAccountId().subscribe((accountId) => {
      if (!accountId) {
        this.giveUpSelfHeal();
        return;
      }

      // Reads b2bUnitId from a dedicated request/response pair instead of
      // this.b2bUnitId / userAccountDetails$ (a shared singleton also
      // written by MiniCartComponent, StandardCartComponent, ... - a
      // take(1) subscription to it can't tell a value another component
      // already populated *for a different account* from the fresh one
      // requested just below, since a BehaviorSubject replays whatever it
      // currently holds immediately on subscribe). getUserAccountDetailsDataFromDb()
      // is still called (below) as a fire-and-forget side effect so the
      // rest of the page (order-block banner via getUserAccountData()'s
      // own, separate, ongoing subscription) still updates the normal way.
      this.selfInitUserAccountSub = this.baseService
        .get(`${config.USER_ACCOUNT}${userId}/b2bUnits/${accountId}`, { fields: 'FULL' })
        .pipe(map((res: any) => res?.uid), take(1))
        .subscribe({
          next: (b2bUnitId: string) => {
            if (!b2bUnitId) {
              this.giveUpSelfHeal();
              return;
            }

            this.runCartCheckAndCheckout(userId, b2bUnitId);
          },
          error: () => {
            this.giveUpSelfHeal();
          },
        });

      this.addToCart.getUserAccountDetailsDataFromDb(userId, accountId);
    });
  }

  /**
   * Resolves the actual current (standard, unsaved) cart and calls
   * cartCheck() + checkoutCartPage() - see the docstring on
   * ensureCheckoutCartDetailsFresh() above for why cartCheck() runs first
   * and why deliveryDate/shippingDate prefer requestedDeliveryDate when
   * still valid in its response's deliveryDates, with shippingInfos
   * matched by delivery date (fallback: deliveryDates[0]). Only filters
   * out saved carts and non-STANDARD
   * ones (e.g. an INFLUENZA cart, checked out via a different page
   * entirely - see MiniCartComponent's own cartType === 'INFLUENZA'
   * filter) - a real B2B account can have both at once, and this file's
   * checkout page is for the standard cart only.
   */
  private runCartCheckAndCheckout(userId: string, b2bUnitId: string): void {
    this.addToCart.getAllCarts(userId);
    this.selfInitAllCartsSub = this.addToCart.allCartItems$
      .pipe(filter((res: any) => !!res), take(1))
      .subscribe((res: any) => {
        // cartType lives on each *childCart*, not on the parent cart
        // getAllCarts() returns (confirmed live - the parent object has no
        // cartType field of its own, so filtering on cart?.cartType here
        // excluded every cart and broke self-heal entirely). Mirrors
        // MiniCartComponent's own INFLUENZA filter, which likewise reads
        // data?.childCarts, not the parent.
        const carts = (res?.carts ?? []).filter(
          (cart: any) =>
            cart?.saveTime === undefined &&
            cart?.childCarts?.some((childCart: any) => childCart?.cartType === 'STANDARD')
        );
        const cart = carts[carts.length - 1];
        if (!cart?.code) {
          this.giveUpSelfHeal();
          return;
        }

        this.selfInitCartCheckSub = this.addToCart
          .cartCheck(cart.code, userId, { b2bUnitId, standardCheckout: true })
          .subscribe({
            next: (checkRes: any) => {
              const childCarts = checkRes?.carts?.[0]?.childCarts;
              if (!childCarts?.length) {
                this.giveUpSelfHeal();
                return;
              }

              const deliveryDates = childCarts.map((childCart: any) =>
                this.buildSelfHealDeliveryDateEntry(childCart)
              );
              this.addToCart.checkoutCartPage({ b2bUnitId, deliveryDates }, cart.code);

              // Deliberately NOT resetting selfHealInFlight/isCheckoutCartLoading
              // here - checkoutCartPage() just reset checkoutCartDetails.value to
              // false and won't repopulate it until its POST resolves, so an
              // early reset would let a re-emission of the outer user.get()
              // subscription pass both guards and start a second, overlapping
              // self-heal + POST while this one is still in flight. The success
              // path resets both flags in getCartDetails()'s existing
              // checkoutCartDetails$ subscription; this listens for the failure
              // counterpart (mirrors proceedToCheckoutPage()'s own
              // checkoutCartDetails$/checkoutCartFailed$ pairing a few hundred
              // lines down) so a rejected POST doesn't leave the page stuck with
              // both flags true and the spinner spinning forever.
              this.selfInitCheckoutFailedSub = this.addToCart.checkoutCartFailed$
                .pipe(filter((res: any) => !!res), take(1))
                .subscribe(() => this.giveUpSelfHeal());
            },
            error: () => {
              this.giveUpSelfHeal();
            },
          });
      });
  }

  private buildSelfHealDeliveryDateEntry(childCart: any): {
    childCartId: string;
    deliveryDate: string;
    shippingDate: string;
  } {
    const options: string[] = childCart?.deliveryDates ?? [];
    const shippingInfos: any[] = childCart?.shippingInfos ?? [];

    // Calendar-day prefix only (same idea as getRequestedDate): avoids
    // local-time shift when comparing date-only picks (e.g. Next flush
    // YYYY-MM-DD) to OCC ISO timestamps (…T00:00:00+0000).
    const calendarDay = (value: string | undefined): string => {
      if (!value) return '';
      return value.split('T')[0];
    };

    const isOption = (day: string, candidate: string | undefined): boolean =>
      !!candidate && calendarDay(candidate) === day;

    let deliveryRaw: string | undefined = childCart?.requestedDeliveryDate;

    if (deliveryRaw) {
      const requestedDay = calendarDay(deliveryRaw);
      const stillValid = options.some((opt) => isOption(requestedDay, opt));
      if (!stillValid) {
        deliveryRaw = undefined;
      }
    }

    if (!deliveryRaw) {
      deliveryRaw = options[0];
    }

    const deliveryDate = calendarDay(deliveryRaw);

    // Match by delivery date only — same as proceedToCheckoutPage(). Do not
    // fall back to shippingInfos[0]: that pairs a later delivery day with the
    // earliest ship day when no row matches.
    const matchedShip = shippingInfos.find((info) =>
      isOption(deliveryDate, info?.deliveryDate)
    );
    const shippingRaw = matchedShip?.shippingDate;

    return {
      childCartId: childCart.code,
      deliveryDate,
      shippingDate: calendarDay(shippingRaw),
    };
  }

  /** Gives up on the self-heal attempt: stops the loading spinner too, rather than spinning forever. */
  private giveUpSelfHeal(): void {
    this.selfHealInFlight = false;
    this.isCheckoutCartLoading = false;
  }

  /**
   * Lookup key for getUserAccountDetailsDataFromDb() - see the docstring
   * above. Prefers the legacy session's selected location
   * (StandardCartComponent.getB2BUid()'s exact source); falls back to the
   * account's default unit (GET_ACCOUNT_ID) so this doesn't depend on
   * legacy-app session state that a cross-app arrival won't have. Never
   * errors - a failed GET_ACCOUNT_ID call resolves to undefined (handled
   * by the "can't resolve account" exit in ensureCheckoutCartDetailsFresh())
   * instead of leaving selfHealInFlight stuck true with no subscriber to
   * ever reset it.
   */
  private resolveSelfHealAccountId(): Observable<string | undefined> {
    const sessionAccountId = this.getSelectedAccountId();
    if (sessionAccountId) {
      return of(sessionAccountId);
    }
    return this.baseService
      .get(config.GET_ACCOUNT_ID)
      .pipe(
        map((res: any) => res?.defaultB2BUnit?.uid),
        take(1),
        catchError(() => of(undefined))
      );
  }

  /**
   * Mirrors StandardCartComponent.getB2BUid() - the account's currently
   * selected location. Unlike that version, wrapped in try/catch: this is
   * called synchronously at the top of ensureCheckoutCartDetailsFresh(),
   * outside any RxJS pipe, so a corrupted sessionStorage value throwing
   * here would abort the rest of getCartDetails() too (contact details,
   * removedEntries, ...), not just self-heal.
   */
  private getSelectedAccountId(): string | undefined {
    try {
      const key = 'selectedLocations' in sessionStorage ? 'selectedLocations' : 'defaultLocation';
      const stored = sessionStorage.getItem(key);
      return stored ? JSON.parse(stored)[0]?.accountNumber : undefined;
    } catch {
      return undefined;
    }
  }

  validateOrderByName(event) {
    if (event?.length === 0) {
      this.orderByErrorMsg = true;
    } else {
      this.orderByErrorMsg = false;
    }
  }
  validateFaxNumber(event, type, i) {
    let newVal;







    if (event?.length === 12) {
      if (type === 'phone') {
        this.phoneErrorMsg = true;
      }
      if (type === 'mobile') {
        this.mobileList.forEach((el, index) => {
          el.iserror = false;
        })
        this.mobileErrorMsg = true;
      }
      if (type === 'fax') {
        this.faxErrorMsg = true;
      }
      newVal = event?.replace(/\D/g, '');
      if (newVal?.length === 0) {
        newVal = '';
      } else if (newVal?.length <= NumberThree) {
        newVal = newVal?.replace(/^(\d{0,3})/, '$1');
      } else if (newVal?.length <= NumberSix) {
        newVal = newVal?.replace(/^(\d{0,3})(\d{0,3})/, '$1-$2');
      } else if (newVal?.length <= NumberTen) {
        newVal = newVal?.replace(/^(\d{0,3})(\d{0,3})(\d{0,3})/, '$1-$2-$3');
      } else {
        newVal = newVal?.substring(0, NumberTen);
        newVal = newVal?.replace(/^(\d{0,3})(\d{0,3})(\d{0,3})/, '$1-$2-$3');
      }
      if (newVal === '') {
        newVal = null;
      }







      if (type === 'fax') {
        this.contactDetails.contactFax = newVal;
      }
      if (type === 'phone') {
        this.contactDetails.contactPhone = newVal;
      }
      if (type === 'mobile') {
        this.mobileList.forEach(el => {
          if (el.value === event) {
            el.value = newVal;
          }
        })

      }
    }
    else if (event?.length === 0) {
      if (type === 'phone') {
        this.phoneErrorMsg = false;
      }
      if (type === 'mobile') {
        this.mobileErrorMsg = false;
      }
      if (type === 'fax') {
        this.faxErrorMsg = true;
      }
    }
    else {
      if (type === 'phone') {
        this.phoneErrorMsg = false;
      }
      if (type === 'mobile') {
        this.mobileList.forEach((el, index) => {
          if (index === i) {
            el.iserror = true;
          }


        })

      }
      if (type === 'fax') {
        this.faxErrorMsg = false;
      }
      if (event === null) {
        return null;
      }
      newVal = event?.replace(/\D/g, '');
      if (newVal?.length === 0) {
        newVal = '';
      } else if (newVal?.length <= NumberThree) {
        newVal = newVal?.replace(/^(\d{0,3})/, '$1');
      } else if (newVal?.length <= NumberSix) {
        newVal = newVal?.replace(/^(\d{0,3})(\d{0,3})/, '$1-$2');
      } else if (newVal?.length <= NumberTen) {
        newVal = newVal?.replace(/^(\d{0,3})(\d{0,3})(\d{0,3})/, '$1-$2-$3');
      } else {
        newVal = newVal?.substring(0, NumberTen);
        newVal = newVal?.replace(/^(\d{0,3})(\d{0,3})(\d{0,3})/, '$1-$2-$3');
      }
      if (newVal === '') {
        newVal = null;
      }







      if (type === 'fax') {
        this.contactDetails.contactFax = newVal;
      }
      if (type === 'phone') {
        this.contactDetails.contactPhone = newVal;
      }
      if (type === 'mobile') {
        this.mobileList.forEach(el => {
          if (el.value === event) {
            el.value = newVal;
          }
        })

      }

    }

  }
  removeEntriesMapping() {
    this.removeEntriesSub = this.addToCart.removedItems$.subscribe(
      (res: any) => {
        if (res) {
          let removedData = res?.removedEntries?.cartModifications;
          let stdCartDetails;
          this.yfEntry = false;
          stdCartDetails = res?.childCarts;
          if (stdCartDetails) {
            stdCartDetails = stdCartDetails.filter(
              (item) => item

            );
            if (stdCartDetails && stdCartDetails?.length > 0) {
              stdCartDetails = Object.assign({}, ...stdCartDetails);
              for (let entries of stdCartDetails?.entries) {
                if (entries?.product?.yellowFever) {
                  this.yfEntry = true;
                }
              }
            }
          }
          if (!stdCartDetails?.shipToParty?.yellowFeverFlag && this.yfEntry) {
            this.yfEntry = true;
          } else {
            this.yfEntry = false;
            this.globalMessage.remove(GlobalMessageType.MSG_TYPE_ERROR);
          }
          if (removedData && removedData?.length > 0) {
            for (const data of removedData) {
              if (
                !stdCartDetails?.shipToParty?.yellowFeverFlag &&
                this.yfEntry
              ) {
                this.globalMessage.add(
                  this.convertHtmlToPlainTxt(data.statusMessage),
                  GlobalMessageType.MSG_TYPE_ERROR,
                  5000000
                );
              } else {
                this.globalMessage.add(
                  this.convertHtmlToPlainTxt(data.statusMessage),
                  GlobalMessageType.MSG_TYPE_ERROR
                );
              }
            }
          }
          this.addToCart.getAllCarts(this.userAccountgetData?.uid);
          this.addToCart.removedItems.next(false);
        }
      }
    );
  }
  deleteEmail(i) {
    this.emailArr.splice(i, 1);
    if (this.emailArr.length < 3) {
      this.noshowaddemail = false;
    }
  }
  cMethodElection(method) {
    if (method === 'fax') {
      this.cMethodVal = false;
      this.emailArrCopy = [...this.emailArr];
      this.emailArr = [{ id: '', value: 'ns', iserror: false, itemValue: '' }];
    }





    else {
      if (!this.cMethodVal) {
        !this.faxValid ? this.faxValid = true : this.faxValid; //USCOMIS-17304 fix
        this.cMethodVal = true;
        this.emailArr = [...this.emailArrCopy];
        this.emailArrCopy = [];
      }
    }
  }
  deleteMobile(i) {
    this.mobileList.splice(i, 1);
    if (this.mobileList.length < 3) {
      this.noshowaddmobile = false;
    }
  }
  cartDataMapping(data): void {

    this.productEntries = [];
    this.cartId = data?.code;

    this.stdCartDetails = data?.childCarts;

    this.headerLevelObj = this.stdCartDetails.filter((el) => el.hidePriceForTotals);
    this.saveCartName =
      JSON.parse(sessionStorage.getItem('selectedLocations'))?.length <= 1
        ? this.stdCartDetails[0]?.shipToLoc_name
        : '';
    this.stdCartDetails?.forEach((el) => {
      this.totalSavings = 0.0;
      let TotalTaxCal = 0.0;
      el['poError'] = false;    //added for po restriction

      el['POnumber'] = el?.purchaseOrderNumber ? el?.purchaseOrderNumber : ''; //binding in case coming in response for upload template
      el['attention'] = '';
      let locationTot = 0.0;
      let finalDiscount = 0.0;
      el.entries.forEach((ele) => {
        el['quantity'] = ele.quantity;

        locationTot +=
          ele.totalPrice.value + ele.sim_excise_tax.value * ele.quantity;
        el.totalTax.value += ele.exciseTax.value * ele.quantity;
        finalDiscount +=
          ele.webDiscount.value +
          ele.sim_other_discount.value +
          ele.sim_promptpay_Discount.value +
          ele.sim_site_discount.value;
        if (ele.futureShipExpProd && ele.splitEntriesDeliveryDates.length > 0)
          this.isFutershipAdded = true;
      });
      el['futureShipAdded'] = this.isFutershipAdded;
      el['ProductSummedPrice'] = locationTot;
      el['FinalDiscount'] = finalDiscount;






      el.totalWebDiscount.finalDis = parseFloat(this.totalSavings.toFixed(2));
      this.finalSaving += el.FinalDiscount;
      this.shipToArr.push(el?.shipToParty);
    });

    this.subTotalVal = 0;
    this.totalWithPromtPayDiscountSum = 0;
    this.stdCartDetails.forEach(el => {
      this.totalSavings = this.totalSavings + el.totalDiscounts?.value;
      this.subTotalVal = this.subTotalVal + el.totalPrice?.value;
      this.totalWithPromtPayDiscountSum = this.totalWithPromtPayDiscountSum + el.totalWithPromptPayDiscount.value;
    })

    this.orderContactDetails = data?.childCarts[0].shipToParty?.billingAddress;
    this.payerAddress = data?.childCarts[0].shipToParty?.payerAddress;
    if (this.stdCartDetails && this.stdCartDetails.length > 0) {
      this.expandedItems = this.stdCartDetails.map(() => false);
    }

    if (this.stdCartDetails) {
      this.stdCartDetails = this.stdCartDetails.filter(
        (item) => item

      );
      this.standardCartDetails = Object.assign({}, ...this.stdCartDetails);
      for (let cartDetails of this.stdCartDetails) {
        for (let entries of cartDetails.entries) {
          let imagesFormat = _.clone(
            _.findWhere(entries.product?.images, { format: 'cartIcon' })
          );
          if (imagesFormat) imagesFormat.url = this.baseUrl + imagesFormat?.url;
          this.images = { PRIMARY: imagesFormat };
          entries = { ...entries, ...this.images };
          this.productEntries.push(entries);
        }
      }
      if (this.standardCartDetails?.shipToParty) {


        this.selectedData = this.standardCartDetails?.shipToParty;
      } else {
        if (this.getuserData && this.getuserData?.length > 0) {
          this.selectedData = _.first(
            this.getuserData.filter(
              (item) => item.unitID === this.userAccountgetData?.uid
            )
          );
        }
      }


      this.cdr.detectChanges();
    }
  }
  performQuantityComputation(
    operator,
    idData,
    quantityOfUnits = 1,
    entryNumber,
    childIndex
  ): void {
    const updatedData = String(idData) + '-' + String(childIndex);

    ProductUtils.alterQuantity(operator, updatedData, quantityOfUnits);
    this.updateTotal = true;
    const inputElement = document.getElementById(
      `prodQuantity${updatedData}`
    ) as HTMLInputElement;
    const params = { entryNumber: entryNumber, quantity: inputElement.value };
    if (
      this.updateEntriesData.some(
        ({ entryNumber }) => entryNumber === params.entryNumber
      )
    ) {
      this.updateEntriesData[
        this.updateEntriesData.findIndex(
          (el) => el.entryNumber === params.entryNumber
        )
      ] = params;
    } else {
      this.updateEntriesData = [...this.updateEntriesData, params];
    }
  }
  deleteCart(entryNumber, prodName, childCartIndex): void {
    this.addToCart.deleteCartItem(
      entryNumber,
      this.stdCartDetails[childCartIndex].code,
      this.cartId
    );
    this.deleteCartSub = this.addToCart.deleteItems$.subscribe((res) => {
      if (res) {
        this.addToCart.deleteItems.next(false);
        this.addToCart.removedEntries(
          this.cartId,
          this.userAccountgetData?.uid
        );
        this.removeEntriesMapping();
        this.deleteSuccess = prodName;
        this.addSuccess = false;
      }
    });
  }
  closeAlert() {
    this.deleteSuccess = '';
    this.addSuccess = false;
  }
  closeDangerAlert() {
    this.showDangerAlert = false;
  }
  clearChildCart(): void {
    this.addToCart.clearCart(this.standardCartDetails.code);
  }
  openPopover(popover) {
    popover.open();
  }
  toggleClose() {
    if (this.savePopover) {
      this.savePopover.close();
    }
  }
  toggle(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
    this.errorMsg = '';

  }
  updateCart(): void {
    this.addToCart.updateCartDetails(
      this.standardCartDetails.code,
      this.updateEntriesData,
      this.cartId
    );
    this.cartDetailsSub = this.addToCart.cartDetails$.subscribe((res: any) => {
      if (res) {
        this.updateTotal = false;
        let stdCartDetails = [];
        stdCartDetails = res?.childCarts;
        stdCartDetails = stdCartDetails.filter(
          (item) => item

        );
        this.standardCartDetails = Object.assign({}, ...stdCartDetails);
        this.updateEntriesData = [];
      }
      this.cdr.detectChanges();
    });
    this.cartEntryService.goToCart();
  }
  productDetails(productDetails, i): void {
    const modalRef = this.modalService.open(ProductDetailsComponent, {
      windowClass: `product-details-modal ${this.baseSiteId}`,
    });
    modalRef.componentInstance.productDetails = productDetails;
    modalRef.componentInstance.standardCartCode = this.stdCartDetails[i].code;

    modalRef.componentInstance.unitSection = 'NoUnitsCheckout';
  }

  onDeliveryDateChange(value: Date): void {
    if (value) {
      this.deliveryCrossIcon = true;
      this.deliveryDateFormat = this.datepipe.transform(value, 'yyyy-MM-dd');
    } else {
      this.deliveryCrossIcon = false;
    }
  }
  onPickupDateChange(value: Date): void {
    if (value) {
      this.pickupCrossIcon = true;
      this.pickupDateFormat = this.datepipe.transform(value, 'yyyy-MM-dd');
      if (value.getDate() !== this.minPickupDate.getDate()) {
        this.timeFormat = this.pickupTimeFormat;
        this.selectedTime = _.first(this.timeFormat);
      } else {
        this.setPickupTime();
      }
    } else {
      this.pickupCrossIcon = false;
    }
  }
  clearDate(dpDate): void {
    if (dpDate === 'Delivery') {
      this.deliveryDate = null;
      this.deliveryCrossIcon = false;
    } else {
      this.pickupDate = null;
      this.pickupCrossIcon = false;
      this.selectedTime = null;
    }
  }
  redirectToCheckout(): void {
    this.route.goByUrl('/checkout');
  }

  proceedtoFinal() {
    this.checkoutClicked = true;
    this.emailArr.forEach((el) => {
      if (el.id == -1) {
        this.emailFinalArr.push(el.itemValue)
      }
      else {
        this.emailFinalArr.push(el.value);
      }
    });

    this.mobileList.forEach((el) => {
      this.mobFinalArr.push(el.value);
    });
    let arrFororderOtherInfo = [];
    this.stdCartDetails.forEach((el) => {
      let obj = {
        cartId: el.code,
        purchaseOrderNumber: el.POnumber,
        attaintion: el.attention,
        splInstruction: el.instruction,
      };
      arrFororderOtherInfo.push(obj);
    });
    let emailAdditional = [];
    let mobileNoAdditional = [];
    this.emailFinalArr.forEach(function (value, i) {
      if (i != 0) {
        emailAdditional.push(value);
      }
    });

    this.mobFinalArr.forEach(function (value, i) {
      if (i != 0) {
        mobileNoAdditional.push(value);
      }
    });
    this.modal.dismissAll();

    let obj = {
      paymentMethod: this.selectedPaymentMethodDetails.code,
      paymentType:
        this.selectedPaymentMethodDetails.code !== 'BILL_ME_LATER'
          ? this.selectedCardOrAccountDetails.paymentType
          : '',
      standardCart: true,
      seasonId: '',
      routingNumber:
        this.selectedPaymentMethodDetails.code !== 'BILL_ME_LATER'
          ? this.selectedCardOrAccountDetails.routingNumber
          : '',
      cardType:
        this.selectedPaymentMethodDetails.code !== 'BILL_ME_LATER'
          ? this.selectedCardOrAccountDetails.cardType
          : '',
      cardNumber:
        this.selectedPaymentMethodDetails.code !== 'BILL_ME_LATER'
          ? this.selectedCardOrAccountDetails.cardNumber
          : '',
      expDate:
        this.selectedPaymentMethodDetails.code !== 'BILL_ME_LATER'
          ? this.selectedCardOrAccountDetails.expDate
          : '',
      cardHolderName:
        this.selectedPaymentMethodDetails.code !== 'BILL_ME_LATER'
          ? this.selectedCardOrAccountDetails.cardHolderName
          : '',
      orderContact: {

        name: !this.isAsmUser ? this.contactDetails.contactName : this.contactDetails.asmContactName,
        email: !this.cMethodVal ? '' : this.emailFinalArr[0],
        emailAdditional: emailAdditional,
        phoneNo: this.contactDetails.contactPhone,
        mobileNo: this.mobFinalArr[0],
        mobileNoAdditional: mobileNoAdditional,
        faxPrefered: !this.cMethodVal ? true : false,
        faxNo: this.cMethodVal ? '' : this.contactDetails.contactFax,
        placedBy: this.contactDetails?.placedBy ? this.contactDetails?.placedBy : this.contactDetails.contactName
      },
      orderOtherInfo: arrFororderOtherInfo,
    };

    this.addToCart.createOrdermethod(
      this.cartId,
      this.userAccountgetData.uid,
      obj
    );
    this.addToCart.placeOrder$.subscribe(
      (placeOrderRes) => {
        if (placeOrderRes) {
          if (
            placeOrderRes?.orders[0]?.placeOrderMessage &&
            placeOrderRes?.orders[0]?.placeOrderMessage?.includes(
              'Error while payment authorization'
            )
          ) {




            this.globalMessage.add(
              'Your payment method has been declined. Please use a different form of payment to complete your transaction.',
              GlobalMessageType.MSG_TYPE_ERROR
            );
            this.checkoutClicked = false;
            this.cdr.detectChanges();
            return;
          }
          this.dataLayerAdded(placeOrderRes);
          this.addToCart.getAllCarts(this.userAccountgetData.uid);
          this.sharedService.removeLocalStorage('futureshipModalOpened');
          this.sharedService.removeSessionStorage('tempoData');
          this.sharedService.removeSessionStorage('tempoDataInv');
          this.route.goByUrl('/orderConfirmation');
        }
      },
      (errors) => {
        this.globalMessage.add(
          this.convertHtmlToPlainTxt(errors.message),
          GlobalMessageType.MSG_TYPE_ERROR
        );
      }
    );
  }
  dataLayerAdded(placeOrderRes) {
    let location = JSON.parse(sessionStorage.getItem('selectedLocations'));
    let standardOrders = placeOrderRes?.orders?.filter((item) => item?.cartType === "STANDARD");
    let fluOrders = placeOrderRes?.orders?.filter((item) => item?.cartType !== "STANDARD");
    let standardOrderList = [];
    let fluOrderList = []
    standardOrders?.forEach((element, index) => {
      standardOrderList = [];
      element?.entries?.forEach((entry, index1) => {
        let dataObj = this.dataLayerObjCreation("STANDARD", entry, index1)
        standardOrderList?.push(dataObj);
      });
      if (standardOrderList.length > 0) {
        let obj = {
          orderFullData: element,
          datalayerList: standardOrderList
        }
        this._dataService.addtoDataLayer('purchase', obj, location);
        this._dataService.addtoDataLayer('clearDataLayer', '', '', '');
      }
    });
    fluOrders?.forEach((element, index) => {
      fluOrderList = [];
      element?.entries?.forEach((entry, index1) => {
        let dataObj = this.dataLayerObjCreation("INFLUENZA", entry, index1)
        fluOrderList?.push(dataObj);
      });
      if (fluOrderList.length > 0) {
        let obj = {
          orderFullData: element,
          datalayerList: fluOrderList
        }
        this._dataService.addtoDataLayer('purchase', obj, location);
        this._dataService.addtoDataLayer('clearDataLayer', '', '', '');
      }
    });
  }
  decodeHtmlCharCodes(str) {
    if (str !== undefined || str !== '') {
      str = str?.replace(/<p>/g, '');
      str = str?.replace(/<\/p>/gm, '');
      str = str?.replace(/&trade;/g, '™');
      str = str?.replace(/&lt/g, '<');
      str = str?.replace(/&gt;/g, '>');
      str = str?.replace(/&nbsp;/g, '');
      str = str?.replace(/"/g, '&quot;');
      str = str?.replace(/'/g, '&#039;');
      str = str?.replace(/<sup>&reg;<\/sup>/g, '®');
      str = str?.replace(/<sup>®<\/sup>/g, '®');
      str = str?.replace(/&reg;/g, '®');
      str = str?.replace(/<sup>&trade;<\/sup>/g, '™');
      str = str?.replace(/<sup>™<\/sup>/g, '™');
      str = str?.replace(/<span>/g, '');
      str = str?.replace(/<\/span>/gm, '');
      str = str?.replace(/\n/g, '');
      str = str?.replace(/<br>/g, '');
      str = str?.replace(/&nbsp/g, ' ');
      return str;
    }
  }
  dataLayerObjCreation(cartType, element, index) {
    let dataObj = {
      item_id: element?.product?.code,
      item_name: this.decodeHtmlCharCodes(element?.product?.name),
      affiliation: cartType === "STANDARD" ? "order products" : "influenza products",
      currency: "USD",
      discount: "0",
      index: index,
      item_brand: element?.product?.manufacturer,
      item_category: element?.product?.baseProductInfo?.baseProductDescription,
      item_category2: "",
      item_variant: this.decodeHtmlCharCodes(element?.product?.variantProductDescription),
      price: element?.basePrice?.value,
      quantity: element?.quantity
    }
    return dataObj
  }

  continueDisableCheck() {
    if (this.punchoutCheckout) { //since for punchout, no payment details are required.
      return false;
    }
    if (this.selectedPaymentMethodDetails?.code) {

      if (
        this.selectedPaymentMethodDetails?.code !== 'BILL_ME_LATER' &&
        (this.selectedCardOrAccountDetails?.cardType === undefined ||
          this.selectedCardOrAccountDetails?.cardType === '')
      ) {

        return true;
      }
      if (this.orderBlock || this.checkoutClicked || this.yfEntry) {
        return true;
      }
      return false;
    }
  }

  proceedToCheckout(): void {
    if (
      this.deliveryDateFormat ||
      (this.pickupDateFormat && this.selectedTime)
    ) {
      const params = {
        customerId: this.usergetDataObj.uid,
        date:
          this.deliveryPickup === 'delivery' &&
            (this.deliveryDateFormat || this.pickupDateFormat)
            ? this.deliveryDateFormat
            : this.pickupDateFormat,
        deliveryMode:
          this.deliveryPickup === 'delivery' ? 'standard' : 'pickup',
        pickupTime:
          this.deliveryPickup === 'pickup' && this.selectedTime
            ? this.selectedTime
            : '',
        shipToUnitId: this.selectedData?.uid,
        standard: true,
      };
      this.addToCart.checkoutCart(params, this.cartId);
      this.checkoutClicked = true;
      this.checkoutDetailsSub = this.addToCart.checkoutDetails$.subscribe(
        (res) => {
          if (res) {
            this.checkoutClicked = false;
            this.route.goByUrl('/checkout');
          }
        }
      );
      this.checkoutFailedSub = this.addToCart.checkoutFailed$.subscribe(
        (res) => {
          if (res) {
            this.checkoutClicked = false;
          }
        }
      );
    }
  }

  proceedToCheckoutPage() {
    const params = {
      b2bUnitId: this.b2bUnitId,
    };
    this.addToCart.checkoutCartPage(params, this.cartId);
    this.checkoutCartClicked = true;
    this.checkoutCartDetailsSub = this.addToCart.checkoutCartDetails$.subscribe(
      (res) => {
        if (res) {
          this.checkoutCartClicked = false;
          this.route.goByUrl('/checkout');
        }
      }
    );
    this.checkoutCartFailedSub = this.addToCart.checkoutCartFailed$.subscribe(
      (res) => {
        if (res) {
          this.checkoutCartClicked = false;
        }
      }
    );
  }

  open(content): void {
    this.searchedClientList = this.getuserData;
    this.modalService
      .open(content, { ariaLabelledBy: 'modal-basic-title' })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  getUserAccountData(userId): void {
    this.userAccountDetailsSub = this.addToCart.userAccountDetails$.subscribe(
      (userDataget) => {
        if (userDataget) {
          this.usergetDataObj = userDataget.res;
          this.getuserData = userDataget.res.shippingAddresses;
          this.searchedClientList = userDataget.res.shippingAddresses;
          this.b2bUnitId = userDataget?.res?.uid;
          this.orderBlock = userDataget?.res?.orderBlockFlag ? true : false;
          if (this.orderBlock) {
            this.showDangerAlert = true;
          }
          this.changeLocation = this.getuserData?.length <= 1 ? false : true;
          this.cdr.detectChanges();
        }
      }
    );
  }

  onOptionsSelected(data) {
    this.listSelectedData = data;
  }

  onSubmit(): void {
    if (this.listSelectedData !== undefined) {
      this.selectedData = this.listSelectedData;
      this.addToCart.saveLocation(
        this.selectedData?.uid,
        this.cartId,
        this.userAccountgetData?.uid
      );
      this.changedLocSub = this.addToCart.changedLocation$.subscribe((res) => {
        if (res) {
          this.addToCart.removedEntries(
            this.cartId,
            this.userAccountgetData?.uid
          );
          this.removeEntriesMapping();
        }
      });
    }
  }
  SearchClientName(data: any) {
    if (data.length > 0) {
      this.searchedClientList = this.getuserData.filter(
        (x) =>
          (x.companyName !== undefined &&
            x.companyName.toLowerCase().indexOf(data.toLowerCase()) >= 0) ||
          (x.unitID !== undefined &&
            x.unitID.toLowerCase().indexOf(data.toLowerCase()) >= 0) ||
          (x.line1 !== undefined &&
            x.line1.toLowerCase().indexOf(data.toLowerCase()) >= 0) ||
          (x.line2 !== undefined &&
            x.line2.toLowerCase().indexOf(data.toLowerCase()) >= 0) ||
          (x.town !== undefined &&
            x.town.toLowerCase().indexOf(data.toLowerCase()) >= 0) ||
          (x.postalCode !== undefined &&
            x.postalCode.toLowerCase().indexOf(data.toLowerCase()) >= 0)
      );
    } else {
      this.searchedClientList = this.getuserData;
    }
  }
  saveOrder(): void {
    let reg = /^[^`!@#~$%\^&*()_+\-={};':"\\|[\]\\.,<>/\/?~]*$/;
    if (this.saveCartName && RegExp(reg).test(this.saveCartName)) {
      this.addToCart.saveCartDetails(this.saveCartName, this.cartId, true);
      this.saveCartInvalidSub = this.addToCart.invalidCartName$.subscribe(
        (res) => {
          if (res) {
            for (let error of res?.error?.errors) {
              this.errorMsg = error?.message;
            }
          }
        }
      );
      this.saveCartSuccessSub = this.addToCart.saveCartSuccess$.subscribe(
        (res) => {
          if (res) {
            if (this.savePopover) {
              this.savePopover.close();
            }
            this.errorMsg = '';
            this.saveCartName = this.selectedData?.name?.slice(0, 30);
          }
        }
      );
    } else {
      if (this.saveCartName) {
        this.errorMsg = 'Save cart name is not valid.';
      } else {
        this.errorMsg = 'Cart name cannot be blank.';
      }
    }
  }
  exportXls() {
    let cartProducts = [];
    for (let cartItem of this.stdCartDetails) {
      for (let entries of cartItem.entries) {
        cartProducts.push({
          Customer: cartItem.shipToLoc_id + ' ' + cartItem.shipToLoc_name,
          Material: entries?.product?.code,
          Quantity: entries?.quantity,
        });
      }
    }
    this.addToCart.downloadXls(cartProducts, 'Checkout');
  }
  omit_special_char(event) {
    this.errorMsg = '';
    let reg = /^[^`!@#~$%\^&*()_+\-={};':"\\|[\]\\.,<>/\/?~]*$/;
    return new RegExp(reg).test(event.key);
  }
  setDeliveryDate() {
    this.minDeliveryDate.setDate(this.minDeliveryDate.getDate());
    if (
      this.minDeliveryDate.getDay() === 0 ||
      this.minDeliveryDate.getDay() === 6
    ) {
      for (let i = 1; i <= 3; i++) {
        this.minDeliveryDate.setDate(this.minDeliveryDate.getDate() + 1);
        if (
          this.minDeliveryDate.getDay() !== 0 &&
          this.minDeliveryDate.getDay() !== 6
        )
          break;
      }
    }
    this.maxDeliveryDate.setDate(this.minDeliveryDate.getDate() + 6);

    this.deliveryDate = this.minDeliveryDate;
  }
  setPickupDate() {
    if (this.currentTime < 12) {

      this.minPickupDate.setDate(this.minPickupDate.getDate());
      if (
        this.minPickupDate.getDay() === 0 ||
        this.minPickupDate.getDay() === 6
      ) {
        for (let i = 1; i <= 3; i++) {
          this.minPickupDate.setDate(this.minPickupDate.getDate() + 1);
          if (
            this.minPickupDate.getDay() !== 0 &&
            this.minPickupDate.getDay() !== 6
          )
            break;
        }
      }
      this.maxPickupDate.setDate(this.minPickupDate.getDate() + 6);
    } else {
      this.minPickupDate.setDate(this.minPickupDate.getDate() + 1);
      if (
        this.minPickupDate.getDay() === 0 ||
        this.minPickupDate.getDay() === 6
      ) {
        for (let i = 1; i <= 3; i++) {
          this.minPickupDate.setDate(this.minPickupDate.getDate() + 1);
          if (
            this.minPickupDate.getDay() !== 0 &&
            this.minPickupDate.getDay() !== 6
          )
            break;
        }
      }
      this.maxPickupDate.setDate(this.minPickupDate.getDate() + 6);
    }
    this.pickupDate = this.minPickupDate;
  }
  setPickupTime() {
    if (this.currentTime < 10) {
      this.timeFormat = this.pickupTimeFormat.slice(3);
    } else if (this.currentTime === 10) {
      this.timeFormat = this.pickupTimeFormat.slice(4);
    } else if (this.currentTime === 11) {
      this.timeFormat = this.pickupTimeFormat.slice(6);
    } else if (this.currentTime > 11 && this.currentTime < 17) {
      this.timeFormat = this.pickupTimeFormat.slice(0);
    } else if (this.currentTime > 16) {
      this.timeFormat = this.pickupTimeFormat.slice(3);
    }
    this.selectedTime = _.first(this.timeFormat);
  }
  toggleAccordion(index: number) {
    this.expandedItems[index] = !this.expandedItems[index];
  }
  getExpandedItems(index: number): boolean {
    return this.expandedItems[index] || false;
  }
  getImage(images: any, imgFormat: string) {
    'thumbnail';
    const imagesFormat = _.clone(_.findWhere(images, { format: imgFormat }));
    let finalImageUrl: string;
    if (imagesFormat) {
      finalImageUrl = `${this.baseUrl}${imagesFormat?.url}`;
    } else {
      if (this.baseSiteId === 'vsh') {
        finalImageUrl = 'i18n-assets/sanofi_missing_product.jpg'
      } else {
        finalImageUrl = 'i18n-assets/sanofi_missing_product_vax.jpg'
      }

    }
    return finalImageUrl;
  }
  getTotalPrice(childCarts) {
    let totalPrice = 0;
    if (childCarts) {
      for (const carts of childCarts) {
        for (const entries of carts?.entries) {
          totalPrice += entries?.totalPrice.value;
        }
      }
    }
    return totalPrice;
  }

  getTotalPriceCalc(childCarts) {
    let totalPrice = 0;
    let totalDiscount = 0;
    if (childCarts) {
      for (const carts of childCarts) {


        carts.entries.forEach((ele) => {
          totalPrice +=
            ele?.totalPrice?.value + ele?.sim_excise_tax.value * ele?.quantity;
          totalDiscount +=
            ele?.sim_other_discount?.value +
            ele?.sim_promptpay_Discount?.value +
            ele?.sim_site_discount?.value +
            ele?.webDiscount?.value;
        });
      }
    }
    return totalPrice + totalDiscount;
  }

  getQuantity(childCarts) {
    let quantity = 0;
    if (childCarts) {
      for (const entries of childCarts) {
        for (const item of entries.entries) {
          quantity += item?.quantity;
        }
      }
    }
    return quantity;
  }

  ngOnDestroy() {
    this.prodAddedSub?.unsubscribe();
    this.cartItemsSub?.unsubscribe();
    this.removeEntriesSub?.unsubscribe();
    this.deleteCartSub?.unsubscribe();
    this.cartDetailsSub?.unsubscribe();
    this.checkoutDetailsSub?.unsubscribe();
    this.checkoutFailedSub?.unsubscribe();
    this.userAccountDetailsSub?.unsubscribe();
    this.changedLocSub?.unsubscribe();
    this.saveCartInvalidSub?.unsubscribe();
    this.saveCartSuccessSub?.unsubscribe();
    this.plpMiniCartSub?.unsubscribe();
    this.userDataSub?.unsubscribe();
    this.globalMessage.remove(GlobalMessageType.MSG_TYPE_ERROR);
    this.localSubscription.unsubscribe();
    this.checkoutCartDetailsSub?.unsubscribe();
    this.checkoutCartFailedSub?.unsubscribe();
    this.selfInitAccountIdSub?.unsubscribe();
    this.selfInitUserAccountSub?.unsubscribe();
    this.selfInitAllCartsSub?.unsubscribe();
    this.selfInitCartCheckSub?.unsubscribe();
    this.selfInitCheckoutFailedSub?.unsubscribe();
    this.cartProdDetails?.unsubscribe();
  }
  stdFluDesc(productentry) {








    return productentry?.product?.description;
  }
  navigateToPdp() {
    this.route.goByUrl('/Open-Catalogue/c/1');
  }
  isWeekDate(date): string {
    let shipImmediateFormat = moment.utc((new Date(date))).format('MM/DD/yyyy') + '<br>(Estimated)';
    let weekOfFormat = 'Week of\n' + moment.utc(new Date(date)).format('MM/DD/yyyy');
    if (localStorage.hasOwnProperty('shipImmediateDateFS') && localStorage.getItem('shipImmediateDateFS')) {
      if (moment.utc(new Date(date)).format('DD/MM/yyyy') === moment.utc(new Date(localStorage.getItem('shipImmediateDateFS'))).format('DD/MM/yyyy'))
        return shipImmediateFormat
      else
        return weekOfFormat;
    }
    else {
      return weekOfFormat;
    }
  }

  getQtyOrShipDate(index, date, quantityVal, action) {
    if (action === 'quantity') {
      if (index === 0) {
        return quantityVal;
      } else {
        return this.isWeekDate(date);
      }
    }
    else {
      if (index === 0) {
        return this.isWeekDate(date);
      }
      else {
        return '';
      }
    }
  }
  convertHtmlToPlainTxt(html){
    let tempDivElement = document.createElement("div");
    tempDivElement.innerHTML = html;
    return tempDivElement.textContent || tempDivElement.innerText || "";
  }

}
